// reportKeys.js
const reportKeys = {
    "no-read": {
      label: "No Read",
      reportId: "7c06ae81-7c4d-443e-93de-febe14387f83",
      groupId: "32ca5e65-3466-420d-a833-099b15ab2abf",
      filters: [],
    },
    "weight-failure": {
      label: "Weight Failure",
      reportId: "3e8f753c-e33c-4fe0-a374-a5e058cceaa6",
      groupId: "32ca5e65-3466-420d-a833-099b15ab2abf",
      filters: [],
    },
    "xpak-statistics": {
      label: "XPAK Statistics",
      reportId: "20790569-ae70-4047-91e6-e95b51732d92",
      groupId: "32ca5e65-3466-420d-a833-099b15ab2abf",
      filters: [],
    },
  };
  export default reportKeys